import { translate } from '@utils/i18n';
import { IndexNamespace } from '@features/ActivityFeed/constants';
export default function getCustomEventDetailsText(version) {
    var _a, _b, _c, _d, _e, _f;
    const changes = version.changes || {};
    const customEventType = (_b = (_a = changes.custom_event_type) === null || _a === void 0 ? void 0 : _a[1]) === null || _b === void 0 ? void 0 : _b.toString();
    const objectName = (_d = (_c = changes.changed_object_name) === null || _c === void 0 ? void 0 : _c[1]) === null || _d === void 0 ? void 0 : _d.toString();
    const objectType = (_f = (_e = changes.changed_object) === null || _e === void 0 ? void 0 : _e[1]) === null || _f === void 0 ? void 0 : _f.toString();
    if (!customEventType || !objectName || !objectType) {
        return '';
    }
    const actionMap = {
        create: 'added',
        update: 'updated',
        delete: 'removed'
    };
    const action = translate(actionMap[customEventType] || '', { namespace: IndexNamespace });
    return `${action} ${objectType}: ${objectName}`;
}
